import React, { useState } from 'react';
import { Card, Button, Container, Row, Col } from 'react-bootstrap';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import styled from 'styled-components';

// ✅ Styled Components for UI
const StyledContainer = styled(Container)`
  background-color: #232830;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

// ✅ Styled Heading for "True or False"
const StyledHeading = styled.h2`
  font-size: 22px;
  font-weight: bold;
  color: #FF7C24;
  margin-bottom: 20px;
  text-align: center;
  margin-top: 10px;
`;

const QuestionText = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 20px;
`;

const StyledCard = styled(Card)`
  background-color: ${(props) => (props.selected ? (props.isCorrect ? '#2ECC71' : '#FF4C4C') : '#FFFFFF')};
  color: ${(props) => (props.selected ? '#FFFFFF' : '#232830')};
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.02);
  }
`;

// ✅ Standardized "Continue" Button
const StandardButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
  border-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  border-radius: 12px;
  padding: 12px;
  width: 80%;
  max-width: 300px;
  margin-top: 20px;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
    border-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
  }
`;

const OnboardingTrueFalseQuestion = ({ question, onNext }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const db = getFirestore();
  const auth = getAuth();

  const handleOptionSelect = async (option) => {
    if (selectedOption === null) {
      setSelectedOption(option);

      // ✅ Determine if the answer is correct
      const correct = option === question.correctanswer;
      setIsCorrect(correct);
      setShowFeedback(true);

      // ✅ Store answer in Firestore
      try {
        const currentUser = auth.currentUser;
        await addDoc(collection(db, 'userpracticesessionanswers'), {
          date: serverTimestamp(),
          lessonid: question.lessonid,
          questionid: question.questionid,
          submittedanswer: option,
          userid: currentUser ? currentUser.uid : 'anonymous',
          iscorrect: correct,
        });
      } catch (error) {
        console.error('Error logging answer:', error);
      }
    }
  };

  const handleContinue = () => {
    onNext(isCorrect);
    setShowFeedback(false);
    setSelectedOption(null);
    setIsCorrect(false);
  };

  return (
    <StyledContainer>
      {/* ✅ Added "True or False" text at the top */}
      <StyledHeading>True or False</StyledHeading>

      <QuestionText>{question.questionname}</QuestionText>

      <Row className="g-3">
        {["✅ True", "❌ False"].map((option, index) => (
          <Col xs={12} key={index}>
            <StyledCard
              onClick={() => handleOptionSelect(option)}
              selected={selectedOption === option}
              isCorrect={isCorrect}
            >
              {option}
            </StyledCard>
          </Col>
        ))}
      </Row>

      {showFeedback && (
        <p style={{ fontSize: '18px', fontWeight: 'bold', color: isCorrect ? '#2ECC71' : '#FF4C4C' }}>
          {isCorrect ? "✅ Correct! Click Continue." : "❌ Incorrect. Click Continue."}
        </p>
      )}

      {showFeedback && (
        <StandardButton onClick={handleContinue}>Continue</StandardButton>
      )}
    </StyledContainer>
  );
};

export default OnboardingTrueFalseQuestion;
